import { render, staticRenderFns } from "./inputText.vue?vue&type=template&id=2bcee4e4&scoped=true"
import script from "./inputText.vue?vue&type=script&lang=js"
export * from "./inputText.vue?vue&type=script&lang=js"
import style0 from "./inputText.vue?vue&type=style&index=0&id=2bcee4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcee4e4",
  null
  
)

export default component.exports